export class Transporter {
  id?: number;
  uri?: string;
  companyName?: string;
  siret?: string;
  vatNumber?: string;
  defaultMarginRate?: number;
  technicalName?: string;
  domainName?: string;
  facebook?: string;
  linkedin?: string;
  twitter?: string;
  youtube?: string;
  website?: string;
  companyAddressFullname?: string;
  companyAddressStreetNumber?: string;
  companyAddressStreet?: string;
  companyAddressZipCode?: string;
  companyAddressCity?: string;
  companyAddressCountry?: string;
  companyAddressAdditionals?: string;
  phone?: string;
  billCgv?: string;
  billCgv2?: string;
  billCgv3?: string;
  billCgv4?: string;
  billCgv5?: string;
  billCgv6?: string;
  billCgv7?: string;
  billSignature?: string;
  billSignature2?: string;
  forcePaymentTestMode?: boolean;
  forceEdiTestMode?: boolean;
  shopName?: string;
  ediId?: string;
  defaultPaymentDelay?: number;

  constructor(data: any = {}) {
    Object.assign(this, data);
    this.forcePaymentTestMode = !!data?.forcePaymentTestMode;
    this.forceEdiTestMode = !!data?.forceEdiTestMode;
  }
}
